import React from 'react';
import {
    Divider,
    Form,
    Input,
    TimePicker,
    Typography,
    DatePicker,
} from 'antd';
import ModalFooterButton from '../ModalFooterButton';
import { createMomentFromDateAndTime } from '../../../utils';
import { required } from '../../../constants/formValidation';


const { Paragraph } = Typography;

const ManualFormStepCustomer = ({ form, submitStep }) => {
    const { getFieldDecorator } = form;

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (err) return;

            submitStep({
                ...values,
                startTime: createMomentFromDateAndTime(values.selectedDate, values.startTime),
                endTime: createMomentFromDateAndTime(values.selectedDate, values.endTime),
            });
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Paragraph strong>
                When is your booking?
            </Paragraph>
            <Form.Item>
                {
                    getFieldDecorator('selectedDate', required()) (
                        <DatePicker placeholder="Booking Date" format="DD-MM-YYYY" />
                    )
                }
            </Form.Item>
            <Form.Item>
                {
                    getFieldDecorator('startTime', required())(
                        <TimePicker minuteStep={30} placeholder="Start Time" format="HH:mm" />
                    )
                }
            </Form.Item>
            <Form.Item>
                {
                    getFieldDecorator('endTime', required())(
                        <TimePicker minuteStep={30} placeholder="End Time" format="HH:mm" />
                    )
                }
            </Form.Item>
            <Divider />
            <Paragraph strong>
                Customer Details
            </Paragraph>
            <Form.Item>
                {
                    getFieldDecorator('fullName', required())(
                        <Input placeholder="Full Name" />
                    )
                }
            </Form.Item>
            <Form.Item>
                {
                    getFieldDecorator('contactNumber')(
                        <Input placeholder="Contact Number" />
                    )
                }
            </Form.Item>
            <Divider />
            <Paragraph strong>
                Customer Address
            </Paragraph>
            <Form.Item>
                {
                    getFieldDecorator('addressLine1', required())(
                        <Input placeholder="Address Line 1" />
                    )
                }
            </Form.Item>
            <Form.Item>
                {
                    getFieldDecorator('city', required())(
                        <Input placeholder="Town / City" />
                    )
                }
            </Form.Item>
            <Form.Item>
                {
                    getFieldDecorator('postcode', required())(
                        <Input placeholder="Postcode" />
                    )
                }
            </Form.Item>
            <ModalFooterButton label="Create Booking" />
        </Form>
    );
};

export default Form.create({ name: 'customer' })(ManualFormStepCustomer);
